var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "bj-modal",
        {
          staticClass: "inspection-timeline-modal",
          attrs: {
            title: "Condition Report #" + _vm.inspection.id + " Timeline",
            position: "right",
            size: { maxWidth: "60vw", minHeight: "100vh", minWidth: "40vw" }
          },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "content",
              attrs: { slot: "content" },
              slot: "content"
            },
            [
              _c("div", { staticClass: "text-grey-7 mb-2" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.capitalize(_vm.inspection.type.split("_").join(" "))
                    ) +
                    " #" +
                    _vm._s(_vm.inspection.id) +
                    "\n    "
                )
              ]),
              _c("div", { staticClass: "text-grey-7" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.inspection.property.short_address) +
                    "\n    "
                )
              ]),
              _c("bj-inner-loading", {
                attrs: { label: "Saving", visible: _vm.loading }
              }),
              _c("q-card-separator", { staticClass: "title-separator" }),
              _vm.activities && _vm.activities.length !== 0
                ? _c(
                    "q-timeline",
                    {
                      staticClass: "inspection-activities-timeline",
                      attrs: {
                        color: "secondary",
                        layout: "dense",
                        side: "right"
                      }
                    },
                    _vm._l(_vm.activities, function(activity, activityIndex) {
                      return _c(
                        "q-timeline-entry",
                        { key: activity.id },
                        [
                          _c("inspection-timeline-activity", {
                            attrs: {
                              inspection: _vm.inspection,
                              activity: activity
                            }
                          }),
                          _c("SdDatetime", {
                            staticClass: "q-timeline-subtitle",
                            attrs: {
                              slot: "subtitle",
                              value: activity.created_at,
                              "market-id": _vm.inspection.property.market_id,
                              timezone: _vm.inspection.property.timezone
                            },
                            slot: "subtitle"
                          })
                        ],
                        1
                      )
                    })
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "row", attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-input", {
                staticClass: "col",
                attrs: {
                  maxlength: 2048,
                  minlength: 2,
                  type: "textarea",
                  "float-label": "Leave a comment...",
                  rows: 2
                },
                model: {
                  value: _vm.comment,
                  callback: function($$v) {
                    _vm.comment = $$v
                  },
                  expression: "comment"
                }
              }),
              _c("q-btn", {
                staticClass: "col-2",
                attrs: {
                  disable: _vm.loading || !_vm.comment,
                  rounded: "",
                  color: "primary",
                  icon: "save",
                  size: "md",
                  outline: "",
                  label: "Comment",
                  "no-caps": ""
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.addComment($event)
                  }
                }
              })
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }